module.exports = __webpack_public_path__ + "static/media/check_red.72ed28a7.svg";